export class LoginTextDataEN {
  static readonly SEOlLabel = {
    appTitle: 'User Login - PDF Remediation Platform | PREP',
  };
  static readonly htmlLabel = {
    appName: 'PDF Remediation Platform',
    ssoUserLogin: 'APPLE USER LOGIN',
    userLogin: 'USER LOGIN',
    appWelcome: 'Welcome to PREP Console',
    requiredFieldMessage: 'Fields marked with an asterisk (*) are required.',
    email: 'E-Mail',
    emailError: 'Please enter your email address',
    emailInvalidError: 'Please enter a valid email address',
    emailFormatHint: 'name@example.com',
    password: 'Password',
    passwordError: 'We need a password to log you in',
    passwordMinLengthError: 'The password should be minimum 6 characters',
    passwordHint: 'Click the eye to toggle visibility',
    rememberMe: 'Remember me for future logins',
    forgotPassword: 'Forgot password?',
    signIn: 'SIGN IN',
    signInLoading: 'Signing in...',
    ssoSignIn: 'SINGLE SIGN-ON',
    ssosignInLoading: 'Single Sign on...',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyHint: 'Before clicking Log In, you can review our company',
    spinnerText: 'Loading, please wait...',
    poweredBy: 'Powered by',
    skipToMain: 'Skip to main content',
  };
  static readonly snackbarLabels = {
    errorInternetConnection: 'Error: Please check Internet Connection!!',
    errorLogin400: 'Error: Sign In Failed. Incorrect E-Mail ID or Password!',
    errorLogin401:
      'Error: Sign In Failed. User Allowed to Login on only one Device',
    SuccessSignIn: 'Sign In Successful. Redirecting to Dashboard.',
  };
  static readonly tooltipLabels = {
    buttonPasswordToggle: 'Show/Hide Password',
  };
  static readonly ariaLabels = {
    main: 'Login page content',
    rememberMe: 'Remember me for future logins',
    forgotPassword: 'Forgot your password?',
    signIn: 'Sign in',
    signInDisabled: 'Sign in (disabled or loading)',
    signInBusy: 'Sign in (loading in progress)',
    showHidePassword: 'Show/Hide',
    passwordVisibilityToggle: {
      true: 'Hide password',
      false: 'Show password',
    },
    privacyNote: 'Privacy policy notice',
    privacyPolicyLink: "View our company's Privacy Policy in a new tab",
    loadingSpinner: 'Loading, please wait',
    spinnerText: 'Loading, please wait',
    loginPreferences: 'Login preferences',
    brandingSection: 'Branding section',
    languageSelector: 'Language selector',
  };
  static readonly altLabels = {
    prepLogo: 'PREP logo',
    continualEngineLogo: 'Continual Engine logo',
  };
}

export class ForgotPasswordTextDataEN {
  static readonly SEOlLabel = {
    appTitle: 'Forgot Password - PDF Remediation Platform | PREP',
  };
  static readonly htmlLabel = {
    appName: 'PDF Remediation Platform',
    appPagetitle: 'FORGOT PASSWORD',
    requiredFieldMessage: 'Fields marked with an asterisk (*) are required.',
    email: 'E-Mail',
    emailError: 'Please enter your email address',
    emailInvalidError: 'Please enter a valid email address',
    emailFormatHint: 'name@example.com',
    buttonSubmit: 'Submit',
    buttonGoBack: 'GO BACK TO LOGIN',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyHint: 'Before clicking Log In, you can review our company',
    spinnerText: 'Loading, please wait...',
    poweredBy: 'Powered by',
    skipToMain: 'Skip to main content',
  };
  static readonly snackbarLabels = {
    errorInternetConnection: 'Error: Please check Internet Connection!!',
    errorGeneric: 'Error: Something went wrong. Please contact support!',
    SuccessSubmit:
      'Reset Password link has been sent to your Email. Please check your Email',
  };
  static readonly ariaLabels = {
    skipLink: 'Skip to main content',
    privacyNote: 'Privacy policy notice',
    privacyPolicyLink: "View our company's Privacy Policy in a new tab",
    spinner: 'Loading, please wait',
  };
  static readonly altLabels = {
    prepLogo: 'PREP logo',
    continualEngineLogo: 'Continual Engine logo',
  };
}

export class ResetPasswordTextDataEN {
  static readonly SEOlLabel = {
    appTitle: 'Reset Password - PDF Remediation Platform | PREP',
  };
  static readonly htmlLabel = {
    appName: 'PDF Remediation Platform  ',
    resetPasswordHeading: 'RESET PASSWORD',
    passwordLabel: 'Password',
    toggleHint: 'Click the eye to toggle visibility',
    resetPasswordButton: 'RESET PASSWORD',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyHint: 'Before clicking Log In, you can review our company',
    spinnerText: 'Loading, please wait...',
    poweredBy: 'Powered by',
  };
  static readonly snackbarLabels = {
    messages: {
      success: 'Password Changed Successfully',
      error_404: 'Url already used or expired!',
    },
    action: 'OK THANKS',
  };
  static readonly tooltipLabels = {
    buttonPasswordToggle: 'Show/Hide Password',
  };
  static readonly ariaLabels = {
    main: 'Reset Password Page Main Content',
    resetPasswordHeading: 'Reset Password',
    togglePasswordVisibility: 'Toggle password visibility',
  };
  static readonly altLabels = {
    prepLogo: 'PREP logo',
    continualEngineLogo: 'Continual Engine logo',
  };
}
